import React, { FC, useEffect } from 'react';
import cs from 'classnames';
import { useTranslation } from '@wix/wix-i18n-config';
import { useParams } from 'react-router';

import { TemplatesGrid } from '../TemplatesGrid/TemplatesGrid';
import { InspirationalTemplatesPage } from './InspirationalTemplatesPage/InspirationalTemplatesPage';
import { useBiLogger } from '../../contexts/BILoggerContext';
import { templatesPageDataHooks } from './TemplatesPage.dataHooks';
import { useSelectedCategory } from '../../hooks/useSelectedCategory';
import { CategorySlug } from '../../config';
import { useSearch } from '../../hooks/useSearch';

import s from './TemplatesPage.scss';

interface TemplatesPageProps {}

const TemplatesPage: FC<TemplatesPageProps> = () => {
  const biLogger = useBiLogger();
  const { t } = useTranslation();
  const { isSearchActive, criteria } = useSearch();
  const { categorySlug = CategorySlug.DEFAULT } = useParams();
  const isInspirationalTemplates = categorySlug === CategorySlug.INSPIRATIONAL;

  useEffect(() => {
    biLogger.reportTemplatesPageView();
  }, [categorySlug, criteria]); // we should report page view on category change or criteria change

  const selectedCategory = useSelectedCategory();

  let heading = '';

  if (selectedCategory) {
    heading = t('app.new.title.category', {
      category: selectedCategory.displayName,
    });

    const isHomePage = selectedCategory.slug === CategorySlug.DEFAULT;

    if (isHomePage) {
      heading = t('app.new.title.home');
    } else if (selectedCategory.slug === CategorySlug.DESIGNED_TEMPLATES) {
      heading = t('app.new.title.designed');
    }
  }

  if (isSearchActive) {
    heading = t('app.new.title.search', { criteria });
  }

  return (
    <main data-hook={templatesPageDataHooks.container()} className={cs(s.main)}>
      {isInspirationalTemplates ? (
        <InspirationalTemplatesPage heading={selectedCategory!.displayName} />
      ) : (
        <TemplatesGrid heading={heading} />
      )}
    </main>
  );
};

export default TemplatesPage;
